import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { container } from '@infrastructure/di/container';
import { QUERY_KEYS } from '@shared/constants';
import type { CreateRequestExamplePayload } from '@core/repositories/RequestExampleRepository';

export const useRequestExamples = (requestId: string | undefined) => {
  return useQuery({
    queryKey: QUERY_KEYS.requestExamples(requestId ?? ''),
    queryFn: () => container.requestExamples.list(requestId as string),
    enabled: Boolean(requestId),
  });
};

export const useCreateRequestExample = (requestId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateRequestExamplePayload) =>
      container.requestExamples.create(requestId, payload),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.requestExamples(requestId) }),
  });
};

export const useRenameRequestExample = (requestId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      name,
      description,
    }: {
      id: string;
      name: string;
      description: string | null;
    }) => container.requestExamples.rename(id, name, description),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.requestExamples(requestId) }),
  });
};

export const useDeleteRequestExample = (requestId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => container.requestExamples.remove(id),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.requestExamples(requestId) }),
  });
};
